import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "my-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "You have logged in with permission:", -1)
const _hoisted_4 = { class: "badge badge-light-success border border-1 border-dashed border-success ms-2" }
const _hoisted_5 = { class: "my-2 d-flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "You can change keys for:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success border border-1 border-dashed border-success ms-2" }, "active", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "badge badge-light-info border border-1 border-dashed border-info ms-2"
}
const _hoisted_10 = { class: "d-block my-3" }
const _hoisted_11 = { class: "d-flex alert alert-primary border border-dashed border-primary border-1 d-flex align-items-center" }
const _hoisted_12 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Public key only, must be 54 characters long and start with PUB_K1", -1)
const _hoisted_14 = {
  key: 0,
  class: "my-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "New owner key", -1)
const _hoisted_16 = { class: "my-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "New active key", -1)
const _hoisted_18 = { class: "d-flex justify-content-end py-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Change permission", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Loading = _resolveComponent("Loading")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.permission), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", null, [
            _hoisted_7,
            (_ctx.permission == 'owner')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "and"))
              : _createCommentVNode("", true),
            (_ctx.permission == 'owner')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "owner"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
              ]),
              _hoisted_13
            ]),
            (_ctx.permission == 'owner')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ownerKey) = $event)),
                    class: "form-control form-control-solid",
                    name: "activeKey",
                    placeholder: "New owner key (Key starts with PUB_K1, leave blank to keep unchanged)"
                  }, null, 512), [
                    [_vModelText, _ctx.ownerKey]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeKey) = $event)),
                class: "form-control form-control-solid",
                name: "activeKey",
                placeholder: "New active key (Key starts with PUB_K1, leave blank to keep unchanged)"
              }, null, 512), [
                [_vModelText, _ctx.activeKey]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-light-success",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePemission()))
            }, _hoisted_20)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
        _createVNode(_component_Loading)
      ]))
}